import React from "react";

const Repair = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <div className="text-sm text-gray-600 mb-4">
        <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Halı Tamir ve Overlok
      </div>

      <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">ANKARA HALI TAMİR & OVERLOK HİZMETİ</h1>

      <div className="space-y-6">
        <p>
          Abone Halı Yıkama olarak, yalnızca halı temizliği değil, aynı zamanda halılarınızın tamir ve overlok işlemlerini de büyük bir titizlikle gerçekleştiriyoruz. Ankara genelinde sunduğumuz bu özel hizmetle halılarınızı yepyeni bir görünüme kavuşturuyoruz.
        </p>

        <p>
          Zamanla yıpranan, kenarlarından sökülen veya iplik atması yapan halılarınız için overlok işlemi oldukça önemlidir. Halının ömrünü uzatır, estetik görünümünü korur ve deformasyonları önler.
        </p>

        <p>
          Ayrıca, halılarınızdaki yırtık, dikiş atması, saçak dökülmesi gibi sorunları da profesyonel halı tamircilerimizle onarıyoruz. Böylece yeni halı almadan mevcut halınızı yıllarca kullanmaya devam edebilirsiniz.
        </p>

        <p>
          Halılarınız evinizden alınır, gerekli tamir ve overlok işlemleri tamamlandıktan sonra temizlenerek tekrar kapınıza kadar teslim edilir. Üstelik tüm işlemler kayıt altında ve garantilidir.
        </p>

        <h2 className="text-xl font-bold text-[#003132]">🧵 Verdiğimiz Tamir ve Overlok Hizmetleri</h2>
        <ul className="list-disc list-inside">
          <li>Kenar overlok (makine dikişi)</li>
          <li>Sökülen saçakların yenilenmesi</li>
          <li>Halı yırtık ve delik onarımı</li>
          <li>Halı kenar sarımı</li>
          <li>Halı küçültme ve kenar düzenleme</li>
          <li>Antika halılar için özel el işçiliği tamir</li>
        </ul>

        <h2 className="text-xl font-bold text-[#003132]">🔧 İşlem Sürecimiz</h2>
        <ol className="list-decimal list-inside space-y-2">
          <li>Halı türü ve hasar analizi</li>
          <li>Gerekli tamir yönteminin belirlenmesi</li>
          <li>El işçiliği veya overlok makinesiyle onarım</li>
          <li>Temizlik ve kurutma</li>
          <li>Son kalite kontrol ve paketleme</li>
          <li>Evinize teslimat</li>
        </ol>

        <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
        <ul className="list-disc list-inside">
          <li>Deneyimli halı tamir ustaları</li>
          <li>Makine overlok ve el işçiliği seçenekleri</li>
          <li>Ücretsiz servis ve garantili hizmet</li>
          <li>Yüzlerce mutlu müşteri ve kaliteli referanslar</li>
          <li>Uygun fiyatlı profesyonel çözümler</li>
        </ul>

        <p>
          Halılarınızı atmak yerine yenilemek ister misiniz? Hemen bizimle iletişime geçin, yıpranmış halılarınız kısa sürede yepyeni bir görünüme kavuşsun.
        </p>
      </div>
    </div>
  );
};

export default Repair;
